import Handlebars from '@sparta.global.vendors/handlebars';
import { composeModule } from '@sparta.global.helpers/module-container-helper/dist/es6.js';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"composeModule")||(depth0 && lookupProperty(depth0,"composeModule"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"site") : depth0),(depth0 != null ? lookupProperty(depth0,"page") : depth0),(depth0 != null ? lookupProperty(depth0,"language") : depth0),(depth0 != null ? lookupProperty(depth0,"env") : depth0),(depth0 != null ? lookupProperty(depth0,"assetPath") : depth0),(depth0 != null ? lookupProperty(depth0,"module") : depth0),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),(depth0 != null ? lookupProperty(depth0,"helpers") : depth0),{"name":"composeModule","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":76}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var sparta_build_config = {
  "name": "@sparta.global.templates/render-module-template",
  "version": "1.0.5",
  "id": "globalRenderModuleTemplate",
  "nameSpace": "global-render-module-template",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        composeModule
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    composeModule
  },
  "dependencies": {
    "@sparta.global.helpers/module-container-helper": "^1.0.14",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  }
};

export { sparta_build_config as default };
